var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "mmp-page-content-wrapper" } }, [
    _c("div", { staticClass: "mmp-main" }, [
      _c("nav", { staticClass: "mmp-fixed-nav" }, [
        _c("div", { staticClass: "mmp-user-info" }, [
          _c(
            "span",
            { staticClass: "mmp-user-avatar" },
            [_c("fa", { attrs: { icon: ["fas", "user"] } })],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "mmp-user-greeting" }, [
            _c("span", { staticClass: "mmp-user-greeting-label" }, [
              _vm._v("Welcome back"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "mmp-user-greeting-name" }, [
              _vm._v(_vm._s(_vm.user ? _vm.user.name : "")),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mmp-nav-actions" }, [
          _vm.globalIsUserAllowed("Change_Password")
            ? _c(
                "button",
                {
                  staticClass: "notif-bell-btn",
                  attrs: {
                    disabled: _vm.isTestAccount,
                    title: _vm.isTestAccount
                      ? "Cannot change password of test account"
                      : "Change Password",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show("ChangePasswordModal")
                    },
                  },
                },
                [_c("fa", { attrs: { icon: ["fas", "key"] } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Release_History")
            ? _c(
                "button",
                {
                  staticClass: "notif-bell-btn",
                  attrs: { title: "Release History" },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show("HistoryModal")
                    },
                  },
                },
                [_c("fa", { attrs: { icon: ["fas", "history"] } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Dashboard_Notifications") && false
            ? _c(
                "button",
                {
                  staticClass: "notif-bell-btn",
                  class: {
                    "notif-bell-btn--active": _vm.notifPanelOpen,
                    "notif-bell-btn--pulse":
                      _vm.notifUnreadCount > 0 && !_vm.notifPanelOpen,
                  },
                  attrs: { title: "Notifications" },
                  on: {
                    click: function ($event) {
                      _vm.notifPanelOpen = !_vm.notifPanelOpen
                    },
                  },
                },
                [
                  _c("fa", { attrs: { icon: ["fas", "bell"] } }),
                  _vm._v(" "),
                  _vm.notifUnreadCount > 0
                    ? _c("span", { staticClass: "notif-bell-badge" }, [
                        _vm._v(
                          _vm._s(
                            _vm.notifUnreadCount > 99
                              ? "99+"
                              : _vm.notifUnreadCount
                          )
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "notif-bell-btn signout-btn",
              attrs: { title: "Sign Out" },
              on: { click: _vm.signOut },
            },
            [_c("fa", { attrs: { icon: ["fas", "sign-out-alt"] } })],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid mmp-dashboard-content",
          class: { "mmp-content--map-max": _vm.mapFullscreen },
        },
        [
          _c(
            "div",
            { staticClass: "row mmp-dashboard-section my-4 no-gutters" },
            [
              _c(
                "div",
                {
                  ref: "leftCol",
                  staticClass: "left-col pr-3",
                  class: { "left-col--scrollbar-visible": _vm.leftColHovered },
                  on: {
                    mouseenter: function ($event) {
                      _vm.leftColHovered = true
                    },
                    mouseleave: function ($event) {
                      _vm.leftColHovered = false
                    },
                  },
                },
                [
                  _vm.globalIsUserAllowed("Dashboard_Customer_Dropdown")
                    ? _c("div", { staticClass: "mmp-customer-select" }, [
                        _c(
                          "label",
                          {
                            staticClass: "mmp-customer-select-label",
                            attrs: { for: "dashboardCustomerSelect" },
                          },
                          [
                            _c("fa", {
                              staticClass: "mmp-customer-select-label-icon",
                              attrs: { icon: ["fas", "eye"] },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Viewing")]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.closeCustomerDropdown,
                                expression: "closeCustomerDropdown",
                              },
                            ],
                            staticClass: "mmp-customer-dropdown",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "mmp-customer-dropdown-toggle",
                                class: { "is-open": _vm.customerDropdownOpen },
                                attrs: {
                                  id: "dashboardCustomerSelect",
                                  type: "button",
                                  "aria-expanded": _vm.customerDropdownOpen,
                                  "aria-haspopup": "listbox",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.customerDropdownOpen =
                                      !_vm.customerDropdownOpen
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "mmp-customer-dropdown-value",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentCustomerName ||
                                          "Select customer"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("fa", {
                                  staticClass: "mmp-customer-dropdown-caret",
                                  attrs: { icon: ["fas", "chevron-down"] },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "transition",
                              { attrs: { name: "mmp-dropdown-fade" } },
                              [
                                _vm.customerDropdownOpen
                                  ? _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "mmp-customer-dropdown-menu",
                                        attrs: { role: "listbox" },
                                      },
                                      _vm._l(
                                        _vm.dashboardOptions,
                                        function (org) {
                                          return _c(
                                            "li",
                                            {
                                              key: org.id,
                                              staticClass:
                                                "mmp-customer-dropdown-option",
                                              class: {
                                                "is-selected":
                                                  org.id ==
                                                  _vm.selectedCustomerOrg,
                                              },
                                              attrs: {
                                                role: "option",
                                                "aria-selected":
                                                  org.id ==
                                                  _vm.selectedCustomerOrg,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.selectCustomer(
                                                    org.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "mmp-customer-dropdown-option-label",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(org.company_name)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              org.id == _vm.selectedCustomerOrg
                                                ? _c("fa", {
                                                    staticClass:
                                                      "mmp-customer-dropdown-check",
                                                    attrs: {
                                                      icon: ["fas", "check"],
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoadTypeMileage
                    ? _c(
                        "div",
                        {
                          staticClass: "chart-card mb-3",
                          class: { "chart-card--compact": _vm.isSingleRegion },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "chart-card-body d-flex flex-column",
                            },
                            [
                              _c("div", { staticClass: "chart-header" }, [
                                _c(
                                  "span",
                                  { staticClass: "chart-header-icon" },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "chart-bar"] },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("h4", { staticClass: "chart-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentCustomerName
                                        ? _vm.currentCustomerName + " - "
                                        : ""
                                    ) + "Mileage by Roadway Type"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "chart-container" },
                                [
                                  _vm.chartLoading
                                    ? _c(
                                        "div",
                                        { staticClass: "chart-loading" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "spinner-border spinner-border-md",
                                            attrs: {
                                              role: "status",
                                              "aria-hidden": "true",
                                            },
                                          }),
                                        ]
                                      )
                                    : [
                                        !_vm.isSingleRegion
                                          ? _c("apexchart", {
                                              key:
                                                "multi-" +
                                                _vm.selectedCustomerOrg,
                                              attrs: {
                                                type: "bar",
                                                width: "100%",
                                                height: "100%",
                                                options: _vm.chartOptions,
                                                series: _vm.series,
                                              },
                                            })
                                          : _c("apexchart", {
                                              key:
                                                "single-" +
                                                _vm.selectedCustomerOrg,
                                              attrs: {
                                                type: "bar",
                                                width: "100%",
                                                height: "100%",
                                                options:
                                                  _vm.singleRegionChartOptions,
                                                series: _vm.singleRegionSeries,
                                              },
                                            }),
                                      ],
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "releases-card w-100 mb-3" }, [
                    _c(
                      "div",
                      { staticClass: "releases-card-body d-flex flex-column" },
                      [
                        _c("div", { staticClass: "releases-header" }, [
                          _c(
                            "span",
                            { staticClass: "releases-header-icon" },
                            [_c("fa", { attrs: { icon: ["fas", "tag"] } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "releases-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.currentCustomerName
                                  ? _vm.currentCustomerName + " - "
                                  : ""
                              ) + "Recent Releases"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("vue-good-table", {
                          staticClass: "releases-table",
                          attrs: {
                            rows: _vm.releaseRows,
                            columns: _vm.releaseColumns,
                            styleClass: "vgt-table modern-table",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "table-row",
                              fn: function (props) {
                                return [
                                  props.column.field == "release_date"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              new Date(
                                                props.row.release_date
                                              ).toLocaleDateString(
                                                _vm.language,
                                                {
                                                  month: "2-digit",
                                                  day: "2-digit",
                                                  year: "numeric",
                                                }
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              props.row[props.column.field]
                                            ) +
                                            "\n                "
                                        ),
                                      ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row layers-row no-gutters",
                      attrs: { id: "mileage" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12 total-mileage-strip" },
                        _vm._l(_vm.totalMileage, function (entry) {
                          return _c(
                            "div",
                            {
                              key: entry.region,
                              staticClass: "total-mileage-card",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "total-mileage-card-body" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "total-mileage-region" },
                                    [_vm._v(_vm._s(entry.region))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "total-mileage-display" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "total-mileage-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              entry.mileage.toLocaleString()
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "total-mileage-unit" },
                                        [_vm._v("mi")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "total-mileage-label" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentCustomerName
                                            ? _vm.currentCustomerName + " - "
                                            : ""
                                        ) + "Total Mileage"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "right-col pl-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "map-card h-100 w-100",
                    class: { "map-card--fullscreen": _vm.mapFullscreen },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "map-card-header d-flex justify-content-between align-items-center",
                      },
                      [
                        _c("div", { staticClass: "map-card-title" }, [
                          _c(
                            "span",
                            { staticClass: "map-card-title-icon" },
                            [_c("fa", { attrs: { icon: ["fas", "map"] } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "map-card-title-text" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.isUshrUser
                                    ? "Map Overlays"
                                    : "Map Overlays"
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "map-fullscreen-btn",
                            attrs: {
                              title: _vm.mapFullscreen
                                ? "Minimize map"
                                : "Expand map",
                              "aria-label": _vm.mapFullscreen
                                ? "Minimize map"
                                : "Expand map",
                            },
                            on: { click: _vm.toggleMapFullscreen },
                          },
                          [
                            _c("fa", {
                              attrs: {
                                icon: [
                                  "fas",
                                  _vm.mapFullscreen
                                    ? "window-minimize"
                                    : "expand",
                                ],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "map-body" }, [
                      _c("div", {
                        staticClass: "h-100 w-100",
                        attrs: { id: "mmp-dashboard-map" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "map-layer-panel",
                          class: {
                            "map-layer-panel--minimized":
                              _vm.layerPanelMinimized,
                          },
                        },
                        [
                          _c("div", { staticClass: "map-layer-panel-header" }, [
                            _c("h4", { staticClass: "map-layer-panel-title" }, [
                              _vm._v("Layers"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "map-layer-panel-minimize",
                                attrs: {
                                  "aria-expanded": !_vm.layerPanelMinimized,
                                  title: _vm.layerPanelMinimized
                                    ? "Expand layers"
                                    : "Minimize layers",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.layerPanelMinimized =
                                      !_vm.layerPanelMinimized
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  attrs: {
                                    icon: [
                                      "fas",
                                      _vm.layerPanelMinimized
                                        ? "chevron-up"
                                        : "chevron-down",
                                    ],
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          !_vm.layerPanelMinimized
                            ? [
                                _c(
                                  "draggable",
                                  {
                                    staticClass: "layer-toggle-list",
                                    attrs: {
                                      tag: "div",
                                      handle: ".layer-drag-handle",
                                    },
                                    on: {
                                      end: function ($event) {
                                        $event.preventDefault()
                                        return _vm.reorderLayers.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.layersButtonsCtrl,
                                      callback: function ($$v) {
                                        _vm.layersButtonsCtrl = $$v
                                      },
                                      expression: "layersButtonsCtrl",
                                    },
                                  },
                                  _vm._l(
                                    _vm.layersButtonsCtrl,
                                    function (layer) {
                                      return _c(
                                        "div",
                                        {
                                          key: layer.name,
                                          staticClass: "layer-row",
                                        },
                                        [
                                          _c("fa", {
                                            staticClass: "layer-drag-handle",
                                            attrs: {
                                              icon: ["fas", "grip-vertical"],
                                              title: "Drag to reorder",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "layer-row-label" },
                                            [_vm._v(_vm._s(layer.display_name))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "layer-toggle-switch",
                                              class: { "is-on": layer.visible },
                                              attrs: {
                                                "aria-pressed": layer.visible,
                                                title: layer.visible
                                                  ? "Hide layer"
                                                  : "Show layer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleLayer(
                                                    layer.name
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "layer-toggle-knob",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                !_vm.layersButtonsCtrl.length
                                  ? _c(
                                      "p",
                                      { staticClass: "text-muted mb-0" },
                                      [
                                        _vm._v(
                                          "\n                  No layers loaded yet.\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mmp-copyright" }, [
        _c(
          "a",
          {
            staticClass: "mmp-attribution",
            attrs: { href: "https://dmp-maps.com/legal/", target: "_blank" },
          },
          [
            _vm._v(
              "\n      © " +
                _vm._s(new Date().getFullYear()) +
                " Dynamic Map Platform North America, Inc. All Rights Reserved\n    "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.globalIsUserAllowed("Dashboard_Notifications") && false
      ? _c(
          "div",
          {
            staticClass: "notif-drawer",
            class: { "notif-drawer--open": _vm.notifPanelOpen },
          },
          [
            _c("MMP_Notifications", {
              attrs: { user: _vm.user },
              on: {
                close: function ($event) {
                  _vm.notifPanelOpen = false
                },
                "unread-count": function ($event) {
                  _vm.notifUnreadCount = $event
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }